import React from 'react';

const ArrowDown = ({mainColor}) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3334 8.66667L8.00008 12M8.00008 12L4.66675 8.66667M8.00008 12L8.00008 4"
                  stroke={mainColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>



    );
};

export default ArrowDown;